export default "__VITE_ASSET__BVW1BlG4__"